import { useRequest } from '@features/request/useRequest';
import { useResetStoreData } from '@features/request/useResetStoreData';
import { readFileFromBase64 } from '@utils/readFileFromBase64';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogUEROtherCostTemplateForUpdateGql } from '../catalogUerOtherCostTemplatesQueries';

const requestId = 'otherCostTemplateDataForUpdate';

export const useCatalogOtherCostTemplateDataForUpdate = ({
    setFiles,
    id,
}: {
    setFiles: React.Dispatch<React.SetStateAction<File[]>>;
    id: number | null | undefined;
}) => {
    const dispatch = useDispatch();

    const [otherForUpdateData, otherForUpdateStatus, , otherCostUpdateDataRequest] = useRequest({
        requestId,
        query: catalogUEROtherCostTemplateForUpdateGql,
        withEffect: false,
    });

    const [otherCostTemplatesReset] = useResetStoreData({ requestId });

    const handlerSetFile = useCallback(
        (_content: string | undefined = '', _fileName: string | undefined = '') => {
            if (_content?.length) {
                const file = readFileFromBase64(_content, _fileName);

                setFiles(file ? [file] : []);
            }
        },
        [setFiles],
    );

    useEffect(() => {
        if (id) {
            dispatch(otherCostUpdateDataRequest({ id }));
        }
    }, [dispatch, id, otherCostUpdateDataRequest]);

    useEffect(() => {
        if (otherForUpdateData?.catalogUEROtherCostTemplate?.data?.file) {
            const { dataUrl, name } = otherForUpdateData.catalogUEROtherCostTemplate.data.file;

            handlerSetFile(dataUrl, name);
        }
    }, [handlerSetFile, otherForUpdateData?.catalogUEROtherCostTemplate?.data?.file]);

    return useMemo(
        () => ({
            otherCostTemplatesReset,
            otherForUpdateData: otherForUpdateData?.catalogUEROtherCostTemplate?.data,
            otherForUpdateStatus,
            otherCostUpdateDataRequest,
        }),
        [
            otherCostTemplatesReset,
            otherCostUpdateDataRequest,
            otherForUpdateData?.catalogUEROtherCostTemplate?.data,
            otherForUpdateStatus,
        ],
    );
};
